// season logic — a production season runs 1 sept → 14 aug.
// ported from planner web/worker.js:58-59 and renderer.js:8103.
/** season id for a given date, e.g. "25-26". months are 0-indexed (Sept = 8). */
export function seasonIdFor(d) {
    const y = d.getUTCFullYear();
    const m = d.getUTCMonth();
    const startYear = m >= 8 ? y : y - 1;
    return `${startYear % 100}-${(startYear + 1) % 100}`;
}
/** the DEFAULT season target ("finish") date: 14 aug of the season's end year (UTC).
 *  admins can override the effective target via app-config (report.target_date). */
export function seasonTargetDate(seasonId) {
    const endYY = parseInt(seasonId.split('-')[1] ?? '0', 10);
    return new Date(Date.UTC(2000 + endYY, 7, 14));
}
/**
 * working days available between two dates, matching ProductionReporting.xlsx:
 *   NETWORKDAYS(from, to) + 3
 * i.e. weekdays (Mon–Fri) INCLUSIVE of both endpoints, excluding Saturdays and Sundays, plus the
 * workbook's fixed +3. Both ends are compared as calendar days (UTC), not instants, so the figure
 * doesn't depend on the time of day `from` was taken: on the target day itself it still counts that
 * day (1 + 3 = 4 on a weekday). Returns 0 once the target day has passed so downstream capacity math
 * can't go negative. (The reporting sheet is the source of truth for this figure.)
 */
export function daysAvailUntil(from, to) {
    if (!from || !to)
        return 0;
    const d = new Date(from);
    d.setUTCHours(0, 0, 0, 0);
    const end = new Date(to);
    end.setUTCHours(0, 0, 0, 0);
    if (end < d)
        return 0;
    let n = 0;
    while (d <= end) {
        const wd = d.getUTCDay();
        if (wd !== 0 && wd !== 6)
            n++; // exclude Sunday (0) and Saturday (6)
        d.setUTCDate(d.getUTCDate() + 1);
    }
    return n + 3;
}
//# sourceMappingURL=season.js.map